export default "<!--\n  ~ Copyright (c) 2019. World Wide Generation Ltd\n  -->\n\n<div class=\"media-gallery-wrapper\">\n</div>\n"